import { UserProfile, FetchErrorInfo, SuccessFetchingAction, ErrorFetchingAction } from "../../../..";
import { isEqualJson } from "../../../../utils/equal/equal";
import { UsersAction, fetchUsersActionTypes } from "./usersActions";

export type UsersState = {
    isFetching: boolean,
    data: UserProfile[],
    error?: FetchErrorInfo
}

export const initialActiveUsersState: UsersState = {
    data: [],
    isFetching: false
}

export const activeUsersReducer = (state: UsersState = initialActiveUsersState, action: UsersAction | {type: string, auth0_id: string, result: UserProfile}): UsersState => {
    switch (action.type) {
        case fetchUsersActionTypes.start: {
            return {
                isFetching: true,
                data: state.data
            }
        }
        case fetchUsersActionTypes.success: {
            const successAction = action as SuccessFetchingAction<UserProfile[]>
            const newState: UsersState = {
                isFetching: false,
                data: state.data
            }
            const newActiveUsers = successAction.result.filter(x => x.status === 0) 
            if(!isEqualJson(newActiveUsers, state.data)){
                newState.data = newActiveUsers
            }
            return {
                ...newState
            }
        }
        case 'UPDATE_USER_BY_UID': {
            const successAction = action as {auth0_id: string, result: UserProfile}
            const newState: UsersState = {
                isFetching: false,
                data: state.data.map(u => u.auth0_id === successAction.auth0_id ? successAction.result : u)
            }            

            return {
                ...newState
            }
        }
        case 'UPDATE_PARTIAL_USER_BY_UID': {
            const successAction = action as {auth0_id: string, result: Partial<UserProfile>}
            const newState: UsersState = {
                isFetching: false,
                data: state.data.map(u => u.auth0_id === successAction.auth0_id ? {...u, ...successAction.result} : u)
            }            

            return {
                ...newState
            }
        }
        case fetchUsersActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                isFetching: false,
                data: [],
                error: errorAction.error
            }
        }
        default:
            return state
    }
}